import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook for redirection
import { AuthAlert } from '../AuthAlert'; // Import the alert component
import { API_URL } from '../../utils/constants';
import auth from '../../Auth';
import Breadcrumbs from '../Breadcrumbs';

const TestsTable = () => {
  const [prompts, setPrompts] = useState([]);
  const [showAlert, setShowAlert] = useState(false); // State to control the alert visibility
  const navigate = useNavigate(); // Hook to programmatically navigate

  useEffect(() => {
    function fetchPrompts() {
      const token = auth.syncGetIdToken();
      fetch(`${API_URL}/prompts`, {
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('prompts data: ', data);
          setPrompts(data);
        })
        .catch((error) => console.error('Error fetching prompts:', error));
    }

    fetchPrompts();
  }, []); 

  const createNew = () => {
    navigate('/prompt/new');
  };

  const convertDate = (date) =>
      date
          ? new Date(date).toLocaleString(navigator.language, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })
          : '';

  const crumbs = [
    { path: '/', breadcrumb: 'Home' },
    { path: window.location.href, breadcrumb: "CI/CD" }
  ];
  return (
    <div className='flex flex-col w-full p-8 space-y-4'>
      <Breadcrumbs crumbs={crumbs} />
      <div className='col-span-2 grid grid-cols-1 gap-4'>
        <h1 className='col-span-4 text-2xl font-bold'>Choose Prompt:</h1>
      </div>
      {showAlert && <AuthAlert />}
      <Table isHeaderSticky className='max-h-[70vh] w-full' aria-label='Prompt Library Table'>
        <TableHeader>
          <TableColumn>Prompt Id</TableColumn>
          {/* <TableColumn>Overview</TableColumn> */}
          <TableColumn>Prompt model</TableColumn>
          <TableColumn>Latest version</TableColumn>
          <TableColumn>
            <button onClick={createNew} style={{ backgroundColor: '#000000', padding: '0.5rem 0.7rem', borderRadius: '0.4rem', color: 'white' }}>
              Create New Prompt
            </button>
          </TableColumn>
        </TableHeader>
        <TableBody>
          {prompts.map((prompt, index) => (
            <TableRow key={prompt.prompt_id}>
              <TableCell className='cursor-pointer hover:bg-gray-100' onClick={() => navigate(`/tests/${prompt.prompt_id}`)}>{prompt.prompt_id}</TableCell>
              <TableCell><span >{prompt.model_name === '' ? '-' : prompt.model_name}</span></TableCell>
              <TableCell><span >{convertDate(prompt.version)}</span></TableCell>
              <TableCell />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default TestsTable;
